//@ts-check
import * as d3 from "d3";

/**
 * @module Tooltip  
 */

/**
 * Sets Tooltip Content
 * @param {*} content  - HTML content
 */
export function setTooltipContent(content) {
  this.tooltipContent = content;
}

/**
 * Applies Tooltip
 * @param {*} event Event
 */
export function applyToolTip(event) {
  this.formatTooltipMove(d3.pointer(event), this.tooltip);
  this.tooltip.html(this.tooltipContent)
}

/**
 * Formats Tooltip Move
 * @param {Array<Number>} pointer Pointer
 * @param {*} tooltip Tooltip
 */
export function formatTooltipMove(pointer, tooltip) {
  tooltip
    .style("left", (pointer[0] + 30) + "px")
    .style("top", (pointer[1] + 30) + "px");
}

/**
 * Formats Tooltip Default
 * @param {*} tooltip Tooltip
 */
export function formatTooltipDefault(tooltip) {
  tooltip
    .attr("class", "tooltip")
    .style("position", "absolute")
    .style("opacity", 0)
    .style("font-size", "12px")
    .style("background-color", this.tooltipColor)
    .style("border", 'none')
    .style("border-radius", '3px')
    .style("padding", '5px')
    .style("text-align", 'left')
    .style("color", 'white');
}

/**
 * Formats Tooltip On
 * @param {*} tooltip Tooltip
 */
export function formatTooltipOn(tooltip) {
  tooltip
    .transition()
    .duration(500)
    .style("opacity", 1)
    .style("visibility", "visible");
}

/**
 * Format Tooltip Off
 * @param {*} tooltip Tooltip 
 */
export function formatTooltipOff(tooltip) {
  tooltip
    .transition()
    .duration(500)
    .style("opacity", 1)
    .style("visibility", "hidden");
}